module.exports = __webpack_public_path__ + "img/630463_C30CC3_9B049B_AC04AC-256px.90f83b18.png";